<template>
  <button class="btn app-generic-toggle text-nowrap" :class="[containerClass, buttonClass, sizeClass]" @click="toggle" :disabled="readOnly" :title="toolTip">
    <span class="fa" :class="[iconClass]"></span>
    <span v-show="label">{{ label }}</span>
  </button>
</template>
<script>
  export default {
    name: "generic-toggle",
    props: {
      value: Boolean,
      label: String,
      containerClass: {
        type: String,
        default: 'mx-1'
      },
      sizeClass: {
        type: String,
        default: ''
      },
      buttonClassOn: {
        type: String,
        default: 'btn-success'
      },
      buttonClassOff: {
        type: String,
        default: 'btn-danger'
      },
      iconClassOn: {
        type: String,
        default: 'fa-check-square'
      },
      iconClassOff: {
        type: String,
        default: 'fa-square'
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      toolTip: {
        type: String,
        default: ''
      }
    },
    data() {
      return { 
        toggleState: this.value
      };
    },
    watch: {
      value: function(val) {
        this.toggleState = val;
      }
    },
    computed: {
      buttonClass() {
        return this.toggleState ? this.buttonClassOn : this.buttonClassOff;
      },
      iconClass() {
        return this.toggleState ? this.iconClassOn : this.iconClassOff;
      }
    },
    methods: {
      toggle() {
        this.toggleState = !this.toggleState;
        this.$emit('input', this.toggleState);
        this.$emit('change', this.toggleState);
      }
    }
  };
</script>